export const GRID_CONTAINER_CLASS = 'flex flex-col w-full'; // Flex column for grid layout

export const HEADER_ITEM_CLASS = 'text-[#242529] text-lg font-bold'; // Prevents shrinking in small screens

export const BODY_ITEM_CLASS = 'px-4 py-2 flex-1 flex-wrap break-words'; // Allows word wrapping for long content

export const CONTAINER_CLASS = 'w-[502px] h-[64px] gap-0 hover:bg-gray-100 shadow-list items-center'; // Flex row with vertical alignment

export const HEADER_ITEM_CONTAINER_CLASS = `
  flex 
  flex-col 
  break-words
  xl:flex-row 
  sm:auto
  items-center 
  justify-between 
  min-w-35
  w-auto
  md:flex-row 
  lg:justify-between 
  xl:w-auto

`;
 // Simplified with media queries in place

export const CONTAINER_ITEM_CLASS = 'p-2 px-3 flex-1 truncate'; // Truncate long content with ellipsis

export const CHECKBOX_CLASS = 'cursor-pointer w-4 h-4 accent-blue-800 bg-gray-100 border border-gray-300 rounded'; // Styled checkbox
